import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

/**
 * Every new page starts at the top. On a link or redirect to a different path, jump to the top (or to the
 * `#anchor` when the URL has one) instead of keeping the previous page's scroll. Back/forward (POP) is left to
 * the browser, and a change of only the query string (filters, search) keeps the position. `behavior:
 * "instant"` overrides `html { scroll-behavior: smooth }`, so the jump doesn't animate down a long page.
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  const navigationType = useNavigationType();
  useEffect(() => {
    if (typeof window === "undefined" || navigationType === "POP") return;
    if (hash) {
      const el = document.getElementById(decodeURIComponent(hash.slice(1)));
      if (el) {
        el.scrollIntoView({ behavior: "instant" as ScrollBehavior, block: "start" });
        return;
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" as ScrollBehavior });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- only a new path (or anchor) resets the scroll
  }, [pathname, hash]);
  return null;
};

export default ScrollToTop;
